<template>
	<v-dialog v-model="showDialog" persistent max-width="500">
		<template v-if="requireBtn" v-slot:activator="{ on, attrs }">
			<v-btn
				color="secondary"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
				@dblclick="skipDialogWithDblClick ? accept() : (showDialog = true)"
			>
				<slot name="open-btn-content">
					<v-icon class="mr-1">mdi-check</v-icon>
					{{ accept_text }}
				</slot>
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white">
					{{ confirm_options.title }}</v-toolbar-title
				>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<slot name="text">
					<p style="white-space: pre-wrap;" v-text="confirm_options.description"></p>
				</slot>
			</div>
			<v-card-actions>
				<v-row no-gutters class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<slot name="button">
							<v-btn color="secondary" @click="accept">
								<slot name="accept-text">
									<v-icon class="mr-1">mdi-check</v-icon>
									{{ confirm_options.accept_text }}
								</slot>
							</v-btn>
						</slot>
					</v-col>
					<v-col sm="3" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog"
							>{{ confirm_options.cancel_text }}
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		confirm_options: {
			title: {
				type: String,
			},
			description: {
				type: String,
			},
			accept_text: {
				type: String,
				default: "確認",
			},
			cancel_text: {
				type: String,
				default: "キャンセル",
			},
		},
		accept_text: {
			type: String,
			default: "確認",
		},
		requireBtn: {
			type: Boolean,
			default: false,
		},
		skipDialogWithDblClick: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			title: "",
			message: "",
			dialogByBtn: false,
		}
	},
	methods: {
		accept() {
			this.$emit("accept")
			this.closeDialog()
		},

		openDialog(title, message) {
			this.showDialog = true
			this.title = title
			this.message = message
		},
		closeDialog() {
			this.$emit("cancel")
			this.showDialog = false
			this.title = ""
			this.message = ""
		},
	},
	computed: {
		showDialog: {
			get() {
				if (this.requireBtn) {
					return this.dialogByBtn
				} else {
					return this.dialog
				}
			},
			set(val) {
				if (this.requireBtn) {
					this.dialogByBtn = val
				} else {
					return this.$emit("update:dialog", val)
				}
			},
		},
	},
	watch: {},
}
</script>
